import { PageElement } from 'utils/types'

export const getParsedPageElements = (content?: string): PageElement[] =>
    content ? (JSON.parse(content) as PageElement[]) : []
